import React, { useContext } from 'react';
import { Link as ReactRouterLink } from 'react-router-dom';
import { NamedRouteContext } from 'utils/named_route_context';
import { resolveNamedRoutePath } from 'utils/route_paths';

export default function Link({ to, ...props }) {
  const namedRoutes = useContext(NamedRouteContext);

  return (
    <ReactRouterLink
      {...props}
      to={resolveNamedRoutePath(to, namedRoutes)}
    />
  );
}
